import styled from 'styled-components';
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
// eslint-disable-next-line max-len
import { Row, Col } from 'antd';
import { Div, Icon, FormItem, FormText } from 'ui';

const DetailsItem = styled(FormItem)`
  .ant-legacy-form-item-label {
    line-height: 25px;

    label {
      color: ${p => p.theme.colors.textLight};
    }
  }
  .ant-legacy-form-item-control {
    line-height: 25px;
  }
`;

const StyledIcon = styled(Icon)`
  font-size: 15px;
  margin-right: 5px;
  --fa-secondary-color: #7e7e7e;
  --fa-primary-color: #6bc93c;
  --fa-secondary-opacity: 1;
  color: #7e7e7e;
`;

const LinkIcon = styled(Icon)`
  font-size: 15px;
  margin-left: 5px;
  cursor: pointer;
`;

const HandlingUnitWrapper = styled(Div)`
  width: 100%;
  border-bottom: 3px solid rgba(0, 0, 0, 0.2);
`;

const HandlingUnitTitle = styled(Row)`
  font-weight: 700;
  text-transform: uppercase;
  padding: 30px 0 10px;
  border-bottom: 3px solid rgba(0, 0, 0, 0.2);
`;

const StyledLink = styled.a`
  font-size: 14px;
  text-decoration: underline;
  overflow: hidden;
  text-overflow: ellipsis;
  &:active,
  &:focus {
      color: #0000EE !important;
  }
`;

const HandlingUnit = ({
  logisticsDetails,
  intl,
}) =>
  <>
    <HandlingUnitTitle>
      {intl.formatMessage({ id: 'order.parts.labels.TRACKING_INFORMATION' })}
    </HandlingUnitTitle>
    {
      logisticsDetails?.length ?
        logisticsDetails?.map(logisticsDetail =>
          logisticsDetail?.handlingUnits?.map((handlingUnit, index) =>
            <HandlingUnitWrapper key={index} >
              <Row>
                <Col span={12}>
                  <DetailsItem label={intl.formatMessage({ id: 'order.parts.labels.DELIVERY' })}>
                    <FormText>{logisticsDetail?.deliveryNumber}</FormText>
                  </DetailsItem>
                </Col>
                <Col span={12}>
                  <DetailsItem
                    label={intl.formatMessage({ id: 'order.parts.labels.HANDLING_UNIT' })}
                  >
                    <FormText>{handlingUnit?.handlingUnitExtNumber}</FormText>
                  </DetailsItem>
                </Col>
              </Row>
              <Row>
                <Col span={12}>
                  <DetailsItem label={intl.formatMessage({ id: 'order.parts.labels.QUANTITY' })}>
                    <FormText>
                      {`${handlingUnit?.quantity} ${handlingUnit?.unitOfMeasure}`}
                    </FormText>
                  </DetailsItem>
                </Col>
                <Col span={12}>
                  <DetailsItem
                    label={
                      intl.formatMessage({ id: 'order.parts.labels.LOGISTICS_DELIVERY_DATE' })
                    }
                  >
                    <StyledIcon className={handlingUnit?.logisticsDeliveryDate?.icon} />
                    {handlingUnit?.logisticsDeliveryDate?.fullDescription}
                  </DetailsItem>
                </Col>
              </Row>
              <Row>
                <Col span={12}>
                  <DetailsItem
                    label={intl.formatMessage({ id: 'order.parts.labels.CASE_NUMBER' })}
                  >
                    <FormText>{handlingUnit?.caseNumber}</FormText>
                  </DetailsItem>
                </Col>
                <Col span={12}>
                  <DetailsItem
                    label={intl.formatMessage({ id: 'order.parts.labels.DIMENSIONS' })}
                  >
                    <FormText>
                      {`${intl.formatNumber(handlingUnit?.length || 0, {
                        maximumFractionDigits: 2,
                      })}
                  x ${intl.formatNumber(handlingUnit?.width || 0, {
                        maximumFractionDigits: 2,
                      })}
                  x ${intl.formatNumber(handlingUnit?.height || 0, {
                        maximumFractionDigits: 2,
                      })}
                  ${handlingUnit?.uomDimension}`}
                    </FormText>
                  </DetailsItem>
                </Col>
              </Row>
              <Row>
                <Col span={12}>
                  <DetailsItem
                    label={intl.formatMessage({ id: 'order.parts.labels.NET_WEIGHT' })}
                  >
                    <FormText>
                      {`${parseFloat(handlingUnit?.netWeight || 0).toFixed(3)}
                      ${handlingUnit?.uomWeight}`}
                    </FormText>
                  </DetailsItem>
                </Col>
                <Col span={12}>
                  <DetailsItem
                    label={intl.formatMessage({ id: 'order.parts.labels.GROSS_WEIGHT' })}
                  >
                    <FormText>
                      {`${parseFloat(handlingUnit?.grossWeight || 0).toFixed(3)}
                      ${handlingUnit?.uomWeight}`}
                    </FormText>
                  </DetailsItem>
                </Col>
              </Row>
              <Row>
                <Col span={12}>
                  <DetailsItem label={intl.formatMessage({ id: 'order.parts.labels.FORWARDER' })}>
                    <FormText>{handlingUnit?.forwarder}</FormText>
                  </DetailsItem>
                </Col>
                <Col span={12}>
                  <DetailsItem
                    label={intl.formatMessage({ id: 'order.parts.labels.TRACKING_NUMBER' })}
                  >
                    {handlingUnit?.trackingLink ?
                      <StyledLink
                        target='_blank' href={handlingUnit?.trackingLink}
                      >{handlingUnit?.trackingNumber ?
                        handlingUnit?.trackingNumber : handlingUnit?.trackingLink}
                        <LinkIcon className='fa-solid fa-arrow-up-right-from-square' />
                      </StyledLink> :
                      null
                    }
                  </DetailsItem>
                </Col>
              </Row>
              <Row>
                <Col span={12}>
                  <DetailsItem label={intl.formatMessage({ id: 'order.parts.labels.SIGNER' })}>
                    <FormText>{handlingUnit?.signer}</FormText>
                  </DetailsItem>
                </Col>
              </Row>
            </HandlingUnitWrapper>,
          ),
        ) :
        <Row>{intl.formatMessage({ id: 'order.parts.labels.NO_TRACKING_INFO' })}</Row>
    }
  </>;

HandlingUnit.propTypes = {
  logisticsDetails: PropTypes.array,
  intl: PropTypes.object,
};

export default injectIntl(HandlingUnit);
